import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';

import styles from '../scss/QrCode.module.scss';

export default function CopyButton({ text }) {
    const [copied, setCopied] = useState(false)

    const handleCopy = async () => {
        setCopied(true)

        // Reset icon after 1.5s
        setTimeout(() => setCopied(false), 1500)
    }

    return (
        <CopyToClipboard text={text}>
            <Button
                variant={copied ? "teal" : 'cw-primary-lightest'}
                onClick={handleCopy}
                className={styles.qrCopyButton}
            >
                {copied ? "Copied" : "Copy"}
                <FontAwesomeIcon icon={copied ? faClipboardCheck : faCopy} />
            </Button>
        </CopyToClipboard>
    )
}